module.exports = __webpack_public_path__ + "img/4 - 1 - 2 - 1 - 2.305092b9.jpg";